import GenericNewsImage from "~/core/src/assets/news.png";
import TheRecordImage from "~/core/src/assets/the-record.png";
import DarkReadingImage from "~/core/src/assets/darkreading.png";
import KrebsImage from "~/core/src/assets/krebs.png";
import Law360Image from "~/core/src/assets/law360.png";
import JdSupraImage from "~/core/src/assets/jdsupra.png";
import CyberscoopImage from "~/core/src/assets/cyberscoop.png";
import DataBreachesImage from "~/core/src/assets/databreachesnet.png";
import {isEmpty, isString} from "underscore";

export const whichImage = (news, theme) => {
  if (!isString(news.feed) || isEmpty(news.feed)) return GenericNewsImage;
  const feedName = news.feed;
  if (feedName.match(/BreachRx/i)) return theme.palette.logo;
  if (feedName.match(/The\s?Record/i)) return TheRecordImage;
  if (feedName.match(/Dark\s?Reading/i)) return DarkReadingImage;
  if (feedName.match(/Krebs\s?on\s?Security/i)) return KrebsImage;
  if (feedName.match(/Law360/i)) return Law360Image;
  if (feedName.match(/JD\s?Supra/i)) return JdSupraImage;
  if (feedName.match(/Cyberscoop|Fedscoop/i)) {
    return CyberscoopImage;
  }
  if (feedName.match(/DataBreaches\.net/i)) {
    return DataBreachesImage;
  }
  return GenericNewsImage;
};
